import React, { createContext, useState,useRef } from 'react';
import { Toast } from './components/ErrorPopup/MemberToast';
import Loading from "@/components/Loading/index.js";
export const MyContext = createContext();

function WcipProvider({ children }) {
  const [errorMessage, setErrorMessage] = useState('')
  const [errorMessageTitle, setErrorMessageTitle] = useState('')
  const [errorMessageButtonText, setErrorMessageButtonText] = useState('')
  const [errorMessageConfirmButtonText, setErrorMessageConfirmButtonText] = useState('')
  const [isShowButton, setIsShowButton] = useState('')
  const [type, setType] = useState('wcip')
  const [toastApi, toastContent] = Toast.useMobileToast({ max: 1, position:'fixed' });
  const [isShowLoading, setIsShowLoading] = useState(false)
  const [LoadingType, setLoadingType] = useState('')
  const errorCallback = useRef({});
  const showErrorPopup = (message, t = 'wcip',errorMessageTitle='',errorMessageButtonText='',errorMessageConfirmButtonText='', errorMessageConfirmButtonCallback, isShowButton ) => {
    if (window.location.pathname.includes('/member')){
      t='member';
    }
    if (window.location.pathname.includes('/cssp')){
      t='cssp';
    }
    setErrorMessage(message)
    setErrorMessageTitle(errorMessageTitle)
    setErrorMessageButtonText(errorMessageButtonText)
    setErrorMessageConfirmButtonText(errorMessageConfirmButtonText)
    setIsShowButton(isShowButton)
    setType(t)
    console.log(errorMessageConfirmButtonCallback)
    errorCallback.current.handleConfirm = errorMessageConfirmButtonCallback;
  }
  const loading = {
    show:(type)=>{
      setIsShowLoading(true)
      setLoadingType(type)
    },
    hide:()=>{
      setIsShowLoading(false)
    }
  }
  return (
    <MyContext.Provider value={{ type, showErrorPopup, errorMessage, toastApi, loading,errorMessageTitle,errorMessageButtonText,errorMessageConfirmButtonText,errorCallback, isShowButton }}>
      {children}
      {toastContent}
      <Loading isShowLoading={isShowLoading} type={LoadingType}></Loading>
    </MyContext.Provider>
  );
}

export default WcipProvider